import { Locale } from '../../lib/intl/IntlContext';
export const returnClientIdMessage = (locale: Locale, badClientId: string | undefined) => {
  const cliCopy = badClientId ? badClientId : '';
  if (locale === 'en') return `* The client with ID ${cliCopy} is not in your master data`;
  else return `* Der Mandant mit ID ${cliCopy} befindet sich nicht in Ihren Stammdaten.`;
};

export const returnSupplierMessage = (locale: Locale, badSupplierId: string | undefined) => {
  const suppCopy = badSupplierId ? badSupplierId : '';
  if (locale === 'en') return `* The supplier with ID ${suppCopy} is not in your master data`;
  else return `* Der Lieferant mit ID ${suppCopy} befindet sich nicht in Ihren Stammdaten.`;
};
